import { useMutation } from '@tanstack/react-query';
import { edupassClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';

export enum CertificateSources {
  Eduplay = 'eduplay',
  Lms = 'lms',
}

interface GetCertificateUrlResponse {
  data: {
    certificate_url: string;
  };
}

export const useGetCertificateUrl = (
  courseId: string | number,
  source: string
) =>
  useMutation<GetCertificateUrlResponse>({
    mutationKey: [clientKeys.useGetCertificateUrl, courseId],
    mutationFn: async () => {
      return await edupassClient.post(`/cursos/${courseId}/certificates`, {
        source,
      });
    },
  });
